<div *ngIf="content.title">
  <div class="skymiles-landing-page-quick-links">
    <h3>{{ content.title }}</h3>
    <div class="skymiles-landing-page-quick-links__card">
      <idp-card
        (notify)="clickAnalytics(card, index)"
        *ngFor="let card of content.cards; let index = index"
        [contents]="card"
      ></idp-card>
    </div>
  </div>
</div>
